import Vue from 'vue'
import Component from 'vue-class-component'
import UserHeader from '../shared/UserHeader.vue'
import ConvoReferences from './ConvoReferences.vue'
import ConvoTags from './ConvoTags.vue'
import ConvoComments from './ConvoComments.vue'
import ConvoStatements from '../statement/ConvoStatements.vue'
import EndorseButton from '../buttons/EndorseButton.vue'
import FollowButton from '../buttons/FollowButton.vue'
import CopyButton from "@/components/buttons/CopyButton.vue";
import ShareButton from "@/components/buttons/ShareButton.vue";
import authStore from '@/store/auth/auth-store'
import convoStore from '@/store/convo/convo-store'
import { IConvo } from '@/model/convo'
import EditButton from '@/components/buttons/EditButton'
import CancelButton from '@/components/buttons/CancelButton.vue'
import LoginButton from '@/components/buttons/LoginButton';
import EndorseButtonNonauth from '@/components/buttons/EndorseButtonNonauth';
import ToggleButton from '@/components/buttons/ToggleButton';

@Component({
  name: 'convoView',
  props: ['convo', 'buttonType', ],
  components: {
    'user-header': UserHeader,
    'convo-references': ConvoReferences,
    'convo-tags': ConvoTags,
    'convo-comments': ConvoComments,
    'convo-statements': ConvoStatements,
    'endorse-nonauth-button': EndorseButtonNonauth,
    'login-button': LoginButton,
    'endorse-button': EndorseButton,
    'follow-button': FollowButton,
    'copy-button': CopyButton,
    'share-button': ShareButton,
    'edit-button' : EditButton,
    'cancel-button' : CancelButton,
    'toggle-button' : ToggleButton
  }
})
export default class ConvoView extends Vue {
  protected isEditing = false;
  protected isStatementsHidden = true;
  protected isCommentsHidden = true;

  mounted (): void {
    console.log('ConvoView.ts: mounted')

    this.$store.subscribe((mutation, state) => {
      console.log('ConvoView mutation: type = %j', mutation.type)
      switch(this.getMutationAction(mutation)) {
        case 'edit': 
          this.enableEdit()
          break
        case 'view': 
          this.disableEdit()
          break
      }
    })
  }

  get isEditable () {
    const convo = this.getConvo();
    return authStore.user && convo && convo.meta && convo.meta.creator.id === authStore.user.id
  }

  get convoForm () { return convoStore.state.convoForm }

  protected showStatements (): void {
    this.isStatementsHidden = false;
  }

  protected hideStatements (): void {
    this.isStatementsHidden = true;
  }
  
  protected showComments (): void {
    this.isCommentsHidden = false;
  }

  protected hideComments (): void {
    this.isCommentsHidden = true;
  }

  protected enableEdit (): void {
    this.isEditing = true;
  }

  protected disableEdit (): void {
    this.isEditing = false;
  }

  protected edit (): void {
    convoStore.dispatchEditConvo(this.getConvo());
  }

  protected save (): void {
    convoStore.dispatchUpdateConvo();
  }

  protected cancelEdit (): void {
    convoStore.dispatchResetConvoForm();
  }

  protected editStatements (): void {
    convoStore.dispatchEditConvoStatements(this.getConvo());
  }

  getConvo (): IConvo {
    return this.$props['convo'] as IConvo
  }

  protected likeConvo (): void {
    convoStore.dispatchLikeConvo(this.getConvo())
  }

  protected unlikeConvo (): void {
    convoStore.dispatchUnlikeConvo(this.getConvo())
  }

  protected followConvo (): void {
    convoStore.dispatchFollowConvo(this.getConvo())
  }

  protected unfollowConvo (): void {
    convoStore.dispatchUnfollowConvo(this.getConvo())
  }

  protected copyConvo (): void {
    convoStore.dispatchCopyConvo(this.getConvo())
  }

  private getMutationAction (mutation: any): string {
    console.log('getMutationAction: mutation = %j', mutation)
    let retVal: string = 'none';
    const convo = this.getConvo();
    if (mutation.type === 'convo/editConvo' ) {
      if (mutation.payload && mutation.payload.convo && mutation.payload.convo.id === convo.id) {
        retVal = 'edit'
      } else {
        retVal = 'view'
      }
    } else if (mutation.type === 'convo/updateConvo') {
      retVal = 'view'
    } else if (mutation.type === 'convo/resetConvoForm') {
      retVal = 'view'
    }
    return retVal
  }
}
